module.exports = __webpack_public_path__ + "img/background.e516648c.jpg";